import { HubConnection } from '@microsoft/signalr';
import { INFO_BY_HUB, SvcSignalRHub, SvcSignalRHubInfo } from './svc-signal-r-hub.enum';

export type SvcSignalRConnectionConfig = { autoRetry?: boolean };
export enum SvcSignalRConnectionStatus {
  NONE = 0,
  CONNECTED = 1,
  DISCONNECTED = 2,
  IN_CONNECTING = 3,
  IN_RECONNECTING = 4,
}

export class SvcSignalRConnectionInstance {
  public connection: HubConnection;
  public config: SvcSignalRConnectionConfig;
  public info: SvcSignalRHubInfo;
  public canRetryToConnect = true;
  public status = SvcSignalRConnectionStatus.NONE;
  public timeoutNextReconnection = 5000;
  public onCallbacks: ((method: string, response: unknown) => void)[] = [];

  get isNone(): boolean {
    return this.status === SvcSignalRConnectionStatus.NONE;
  }
  get isInConnectingMoment(): boolean {
    return [SvcSignalRConnectionStatus.IN_RECONNECTING, SvcSignalRConnectionStatus.IN_CONNECTING].includes(this.status);
  }
  get isConnected(): boolean {
    return [SvcSignalRConnectionStatus.CONNECTED].includes(this.status);
  }
  get isDisconnected(): boolean {
    return [SvcSignalRConnectionStatus.DISCONNECTED].includes(this.status);
  }

  constructor(
    public hub: SvcSignalRHub,
    config: { autoRetry?: boolean }
  ) {
    this.info = INFO_BY_HUB[hub];
    this.config = {
      autoRetry: true,
      ...(config ?? {}),
    };
    this.canRetryToConnect = this.config.autoRetry ?? true;
  }

  public setConnection(connection: HubConnection): void {
    this.connection = connection;
  }

  public setStatus(status: SvcSignalRConnectionStatus): void {
    this.status = status;
  }

  public updateConfig(config: SvcSignalRConnectionConfig): void {
    this.config = {
      ...this.config,
      ...(config ?? {}),
    };
  }

  public addListener<T>(fn: (method: string, response: T) => void) {
    if (!this.onCallbacks.some((oc) => oc === fn)) {
      this.onCallbacks.push(fn);
    }
  }

  public removeListener<T>(fn: (method: string, response: T) => void) {
    this.onCallbacks = this.onCallbacks.filter((oc) => oc !== fn);
  }
}

